<app-default-card
  spyTarget="Info"
  [title]="''"
  [info]="''"
  [showChildComponent]="true"
  [showThisComponent]="true">
  Einen Moment bitte
</app-default-card>
